export default __webpack_public_path__ + "static/media/header-img.9f44adec.png";